var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMarkerPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-marker-public",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 216.192,
    height: 300,
    viewBox: "0 0 216.192 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 216.192,
    height: 300,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 216.192,
    height: 51.498,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 248.502)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M216.192,185.2c0,14.221-48.4,25.75-108.1,25.75S0,199.42,0,185.2s48.4-25.749,108.1-25.749,108.1,11.528,108.1,25.749",
    transform: "translate(0 -159.45)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M100.256,0A86.218,86.218,0,0,0,14.038,86.218c0,36.336,50.205,145.665,73.993,195.428a13.551,13.551,0,0,0,24.45,0c23.787-49.763,73.993-159.092,73.993-195.428A86.218,86.218,0,0,0,100.256,0m0,127.937a36.118,36.118,0,1,1,36.118-36.118,36.119,36.119,0,0,1-36.118,36.118",
    transform: "translate(7.84)",
    fill: "#1152e4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarkerPublic);
export default __webpack_public_path__ + "static/media/icon-marker-public.67c33c520bc38ad305fda70f009492e0.svg";
export { ForwardRef as ReactComponent };